import React from "react";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import TextField from "app/components/form/TextField";
import { MOBILE_FACILITY_FORM } from "features/planner/planner.constants";
import ReadOnlyWarning from "features/planner/settings/components/ReadOnlyWarning";

const renderTextField = props => (
  <Field fullWidth margin="normal" component={TextField} {...props} />
);

const EditMobileFacilityForm = ({ handleSubmit, sourceUri }) => {
  if (sourceUri) {
    return (
      <ReadOnlyWarning>
        This facility is read-only and cannot be edited
      </ReadOnlyWarning>
    );
  }

  return (
    <form onSubmit={handleSubmit} id={MOBILE_FACILITY_FORM.ID}>
      <Grid container>
        <Grid item xs={12}>
          {renderTextField({
            label: "Name",
            required: true,
            autoFocus: true,
            name: MOBILE_FACILITY_FORM.NAME,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            label: "Nation",
            required: true,
            name: MOBILE_FACILITY_FORM.NATION,
          })}
        </Grid>
        <Grid item xs={12}>
          {renderTextField({
            label: "Operator",
            name: MOBILE_FACILITY_FORM.OPERATOR,
          })}
        </Grid>
      </Grid>
    </form>
  );
};

export default React.memo(EditMobileFacilityForm);
